'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NewsletterConfig = exports.NewsletterConfig = function NewsletterConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('app.newsletter', {
    url: '^/newsletter',
    template: '<newsletter></newsletter>'
  });
  $stateProvider.state('app.subscriberListing', {
    url: '^/subscribers',
    template: '<subscriber-listing></subscriber-listing>'
  });
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/components/newsletter.config.js
 **/